import { Navigate, useParams } from 'react-router-dom';
import { IntegrationInstancePage } from './IntegrationInstancePage';
import { IntegrationsIndex } from './IntegrationsIndex';
import { isIntegrationKind } from './integration-kinds';
import { useIntegrationCallbackParams } from './useIntegrationCallbackParams';
import { useIntegrationConnectBroadcasts } from './useIntegrationConnectBroadcasts';

type IntegrationsTabProps = {
  memberId: number;
  isHubAdmin: boolean;
};

function parseInstanceId(value: string | undefined): number | null {
  if (value === undefined || !/^\d+$/.test(value)) {
    return null;
  }
  const id = Number(value);
  return Number.isSafeInteger(id) && id > 0 ? id : null;
}

export function IntegrationsTab({ memberId, isHubAdmin }: IntegrationsTabProps) {
  useIntegrationConnectBroadcasts();
  useIntegrationCallbackParams(memberId);
  const { kind, id } = useParams<{ kind?: string; id?: string }>();

  if (kind === undefined && id === undefined) {
    return <IntegrationsIndex memberId={memberId} isHubAdmin={isHubAdmin} />;
  }
  const instanceId = parseInstanceId(id);
  if (isIntegrationKind(kind) && instanceId !== null) {
    return <IntegrationInstancePage kind={kind} id={instanceId} memberId={memberId} isHubAdmin={isHubAdmin} />;
  }
  return <Navigate to="/settings/integrations" replace />;
}
